module.exports = __webpack_public_path__ + "static/media/milosz.1d63f5c6.jpg";